// extracted by mini-css-extract-plugin
module.exports = {"icon-list":"Ir0XI","icon-item":"_1jtad"};